import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

function BlockchainInfo({ results, url }) {
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();

    function showBlockchainInfo() {
        return (
            results &&
            results.transaction_hash &&
            results.callback_transaction_hash &&
            results.hash &&
            results.token &&
            results.hash_algorithm &&
            results.numbers
        );
    }

    function toggle() {
        setExpanded(!expanded);
    }

    function getNumbers() {
        return JSON.stringify(results.transparency_numbers);
    }

    return (
        showBlockchainInfo() && (
            <div className="results-text">
                <h2
                    className={'h2-collapse ' + (expanded ? 'active' : '')}
                    onClick={() => toggle()}
                >
                    {t('blockchainInfo.drawTransparency')} <i className="fas fa-angle-down"></i>
                </h2>
                <div id="drawTransparency" className={expanded ? 'expanded' : ''}>
                    <p>{t('blockchainInfo.thisDrawHasBeenHeldTtransparently')}:</p>

                    <p className="small-padding-top wrap">
                        <a
                            href={`https://etherscan.io/tx/${results.transaction_hash}`}
                            target="_blank"
                            rel="nofollow"
                        >
                            https://etherscan.io/tx/{results.transaction_hash}
                        </a>
                    </p>

                    <p className="small-padding-top">
                        {t('blockchainInfo.andReceivedWithTransaction')}:
                    </p>

                    <p className="small-padding-top wrap">
                        <a
                            href={`https://etherscan.io/tx/${results.callback_transaction_hash}`}
                            target="_blank"
                            rel="nofollow"
                        >
                            https://etherscan.io/tx/{results.callback_transaction_hash}
                        </a>
                    </p>

                    <p className="small-padding-top">{t('blockchainInfo.byDecodingInputData')}:</p>

                    <p className="small-padding-top">
                        <b>{t('blockchainInfo.uniqueHash')}:</b>
                    </p>
                    <p className="wrap code">{results.hash}</p>

                    <p className="small-padding-top">
                        <b>{t('blockchainInfo.uniqueToken')}:</b>
                    </p>
                    <p className="wrap code">{results.token}</p>

                    <h3>{t('blockchainInfo.whereAreTheNumbers')}</h3>

                    <p>
                        <Trans i18nKey="blockchainInfo.afterExactlyOneHour">
                            <b>After exactly one hour and five minutes</b> the draw is publicly
                            decoded. If the required time has passed, you can view the drawn numbers
                            here:
                        </Trans>
                    </p>

                    <p className="small-padding-top wrap">
                        <a
                            href={`https://rng.gg.international/draw/${results.token}`}
                            target="_blank"
                            rel="nofollow"
                        >
                            https://rng.gg.international/draw/{results.token}
                        </a>
                    </p>

                    <p className="small-padding-top">
                        {t('blockchainInfo.noteThatTheUniqueToken')}
                    </p>

                    <p className="small-padding-top">
                        <b>{t('blockchainInfo.algorithm')}</b>
                    </p>
                    <p className="code"> {results.hash_algorithm}</p>
                    <p>
                        <b>{t('blockchainInfo.salt')}:</b>
                    </p>
                    <p className="wrap code"> {results.salt}</p>

                    <p className="small-padding-top">
                        <Trans i18nKey="blockchainInfo.havingTheseValues">
                            Having these values allows you to create the draw hash yourself using
                            HASH HMAC. If you are not a programmer, you can use, for example,{' '}
                            <a
                                href="https://www.freeformatter.com/hmac-generator.html"
                                target="_blank"
                                rel="nofollow"
                            >
                                this
                            </a>{' '}
                            calculator.
                        </Trans>
                    </p>

                    <p className="small-padding-top">
                        <b>{t('blockchainInfo.theStringToHash')}:</b>
                    </p>
                    <p className="code"> {getNumbers()}</p>
                    <p className="small-padding-top">{t('blockchainInfo.theSaltSecretKey')}</p>

                    <p className="small-padding-top wrap">
                        <b>{t('blockchainInfo.youShouldReceiveTheHash')}:</b>
                    </p>
                    <p className="wrap code">{results.hash}</p>

                    <p className="small-padding-top">{t('blockchainInfo.whichProvesTheHash')}</p>
                    <p className="small-padding-top">
                        <Trans i18nKey="blockchainInfo.readMoreAboutTransparency">
                            Read more about our transparency <a href={url}>here</a>.
                        </Trans>
                    </p>
                </div>
            </div>
        )
    );
}

export default BlockchainInfo;
